import { observer } from 'mobx-react-lite'
import { type PayoutDraftingViewModel } from '@/features/payouts/admin/review/PayoutDraftingViewModel'
import {
  Draft,
  DraftingView,
  EmptyDraft,
} from '@/features/payouts/admin/review/components/DraftingView'
import { ApprovedTransactionContainer } from '@/features/payouts/admin/review/components/DraftingView/ApprovedTransaction/ApprovedTransactionContainer'
import { ContentLoading } from '@/components/ContentLoading'
import { ContentError } from '@/components/ContentError'
import { ConfirmPayoutModalContainer } from '@/features/payouts/admin/review/components/ConfirmPayoutModal/ConfirmPayoutModalContainer'

export interface DraftingViewContainerProps {
  vm: PayoutDraftingViewModel
}

export const DraftingViewContainer = observer(function DraftingViewContainer({
  vm,
}: DraftingViewContainerProps) {
  return (
    <DraftingView>
      {vm.fetch.match({
        pending: () => <ContentLoading />,
        rejected: (err) => <ContentError error={err} />,
        resolved: () =>
          vm.approvedTransactions.length === 0 ? (
            <EmptyDraft />
          ) : (
            <Draft
              approvedCount={vm.approvedTransactions.length}
              isDisabled={vm.isBusy}
              onExportCsv={vm.exportCsv}
              onRemoveAll={vm.removeAll}
              total={vm.total}
              canSubmit={vm.canSubmit}
              isSubmitPending={vm.submit.pending}
              onSubmit={vm.requestSubmit}
              confirmModal={
                <ConfirmPayoutModalContainer vm={vm.confirmPayoutVm} />
              }
            >
              {vm.approvedTransactions.map((avm) => (
                <ApprovedTransactionContainer
                  isDisabled={vm.isBusy}
                  key={avm.transaction.id}
                  vm={avm}
                />
              ))}
            </Draft>
          ),
      })}
    </DraftingView>
  )
})
